// src/services/registrationService.js
import * as XLSX from 'xlsx';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const getHeaders = () => {
  const token = localStorage.getItem('auth_token');
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
};

export const registrationService = {
  create: async (data) => {
    try {
      // Format dates properly if they exist
      const formattedData = {
        ...data,
        departure_date: data.departure_date || new Date().toISOString(),
        terminal_entry_date: data.terminal_entry_date || null
      };
      
      /*console.log('Sending registration data to API:', formattedData);
      console.log('API URL:', `${BASE_URL}/registrations/`); */
      
      const response = await fetch(`${BASE_URL}/registrations/`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(formattedData)
      });

      // Get response data regardless of success
      const responseData = await response.json().catch(() => ({}));
      
	  /*  console.log('API response status:', response.status);
      console.log('API response data:', responseData); */
      
      if (!response.ok) {
        throw new Error(
          responseData.detail || 
          (typeof responseData === 'object' ? JSON.stringify(responseData) : 'Failed to create registration')
        );
      }

      return responseData;
    } catch (error) {
      console.error('Create registration error:', error);
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      // Format dates properly if they exist
      const formattedData = {
        ...data,
        departure_date: data.departure_date || null,
        terminal_entry_date: data.terminal_entry_date || null
      };
      
	  /* console.log(`Updating registration ${id} with data:`, formattedData); */
      
      const response = await fetch(`${BASE_URL}/registrations/${id}/`, {
        method: 'PUT',
        headers: getHeaders(),
        body: JSON.stringify(formattedData)
      });

      // Get response data regardless of success
      const responseData = await response.json().catch(() => ({}));
      
      /*console.log('Update API response status:', response.status);
      console.log('Update API response data:', responseData); */

      if (!response.ok) {
        throw new Error(
          responseData.detail || 
          (typeof responseData === 'object' ? JSON.stringify(responseData) : 'Failed to update registration')
        );
      }

      return responseData;
    } catch (error) {
      console.error('Update registration error:', error);
      throw error;
    }
  },

  delete: async (id) => {
    try {
		/*console.log(`Deleting registration ${id}`); */
      
      const response = await fetch(`${BASE_URL}/registrations/${id}/`, {
        method: 'DELETE',
        headers: getHeaders()
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || 'Failed to delete registration');
      }

      return true;
    } catch (error) {
      console.error('Delete registration error:', error);
      throw error;
    }
  },

  getList: async (filters = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      // Properly format and add filters to query params
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          // Special handling for dates to ensure proper format
          if (key === 'dateFrom' && value) {
            queryParams.append('departure_date_from', value);
          } else if (key === 'dateTo' && value) {
            queryParams.append('departure_date_to', value);
          } else {
            queryParams.append(key, value);
          }
        }
      });
      
      const queryString = queryParams.toString();
      const url = `${BASE_URL}/registrations/${queryString ? `?${queryString}` : ''}`;
      
      /*console.log('Fetching registrations from:', url); */
      
      const response = await fetch(url, {
        headers: getHeaders()
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || 'Failed to fetch registrations');
      }

      const data = await response.json();
	  /* console.log('Fetched registrations data:', data); */
      return data;
    } catch (error) {
      console.error('Fetch registrations error:', error);
      throw error;
    }
  },

  exportToExcel: (data) => {
    try {
      // Format the data for Excel
      const formattedData = data.map(item => ({
        'Company': item.company,
        'Truck Number': item.number,
        'Ticket': item.ticket || '-',
        'Phone': item.phone || '-',
        'Departure Date': item.departure_date ? new Date(item.departure_date).toLocaleString() : '-',
        'Status': item.status,
        'Entry Point': item.entry_point || '-',
        'Exit Point': item.exit_point || '-',
		'Parking 40': item.parking_40 || false,
        'Terminal Entry Date': item.terminal_entry_date ? new Date(item.terminal_entry_date).toLocaleString() : '-',
        'Transit In': item.transit_in || 0,
        'Transit Out': item.transit_out || 0,
        'Insurance': item.has_insurance ? 'Yes' : 'No'
      }));

      // Create worksheet
      const ws = XLSX.utils.json_to_sheet(formattedData);

      // Create workbook and append worksheet
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Registrations');

      // Generate filename with current date
      const date = new Date().toISOString().split('T')[0];
      const fileName = `registrations_${date}.xlsx`;

      // Save file
      XLSX.writeFile(wb, fileName);
    } catch (error) {
      console.error('Export failed:', error);
      throw new Error('Failed to export data');
    }
  }
};